const DEFAULT_CONFIG = {
  baseUrl: "",
  endpoints: {
    forms: "/api/forms"
  }
};
export const createFormsApi = (config = {}) => {
  const apiConfig = {
    ...DEFAULT_CONFIG,
    ...config,
    endpoints: {
      ...DEFAULT_CONFIG.endpoints,
      ...config.endpoints
    }
  };
  return {
    async getFormSchema(formId) {
      const response = await fetch(
        `${apiConfig.baseUrl}${apiConfig.endpoints.forms}/${formId}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch form schema: ${response.statusText}`);
      }
      return response.json().then((data) => {
        return data.data;
      });
    },
    async submitForm(formId, values) {
      const { recaptcha, ...rest } = values;
      const headers = {
        "Content-Type": "application/json"
      };
      if (recaptcha) {
        headers["Captcha-Token"] = recaptcha;
      }
      const response = await fetch(
        `${apiConfig.baseUrl}${apiConfig.endpoints.forms}/${formId}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(rest)
        }
      );
      if (!response.ok) {
        let errorMessage = `Failed to submit form: ${response.status}`;
        try {
          const data = await response.json();
          if (data?.message) {
            errorMessage = data.message;
          }
        } catch {
          errorMessage = "Failed to submit form";
        }
        throw new Error(errorMessage);
      }
      return response.json();
    }
  };
};
export const formsApi = createFormsApi();
